import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-dialog-alert',
    templateUrl: './dialog-alert.component.html',
    standalone: false
})
export class DialogAlertComponent implements OnInit, OnDestroy {
    HeaderText = 'Alert!';
    BodyText = '';
    ButtonCloseText = 'Close';
    SubscriptionList: Subscription[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<DialogAlertComponent>
    ) {}

    ngOnInit() {
        // ;
        this.HeaderText = this.data.HeaderText ? this.data.HeaderText : this.HeaderText;
        this.BodyText = this.data.BodyText ? this.data.BodyText : this.BodyText;
        this.ButtonCloseText = this.data.ButtonCloseText ? this.data.ButtonCloseText : this.ButtonCloseText;
    }

    submitForm() {
        this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    ngOnDestroy() {
        this.SubscriptionList.forEach(subs => subs.unsubscribe());
    }
}
